/**
 * Menu rating format helpers shared by member and admin views.
 */

/** "4.5 (12 reviews)" or "No ratings yet". */
export function formatRatingSummary(averageRating: number | null, ratingCount: number): string {
  if (ratingCount === 0 || averageRating === null) return 'No ratings yet';
  return `${averageRating.toFixed(1)} (${ratingCount} review${ratingCount === 1 ? '' : 's'})`;
}
